/* Ampd Bros footer behaviour: live trading-hours light, mobile accordions, country/currency auto-submit. */
(function () {
  'use strict';
  var TZ = 'Australia/Brisbane';
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function fmt(h) {
    var hr = Math.floor(h), m = Math.round((h - hr) * 60);
    return (hr % 12 || 12) + (m ? ':' + (m < 10 ? '0' : '') + m : '') + (hr < 12 ? 'am' : 'pm');
  }

  // Current date/time in Queensland, independent of the visitor's own time zone.
  function nowInBrisbane() {
    var parts = {};
    new Intl.DateTimeFormat('en-AU', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    var y = +parts.year, mo = +parts.month, d = +parts.day;
    return { y: y, mo: mo, d: d, hour: +parts.hour + +parts.minute / 60, dow: new Date(Date.UTC(y, mo - 1, d)).getUTCDay() };
  }

  function isoPlus(now, add) {
    var dt = new Date(Date.UTC(now.y, now.mo - 1, now.d + add));
    return dt.toISOString().slice(0, 10);
  }

  function schedules(cfg) {
    var wk = { 1: [cfg.open, cfg.monThu], 2: [cfg.open, cfg.monThu], 3: [cfg.open, cfg.monThu], 4: [cfg.open, cfg.monThu], 5: [cfg.open, cfg.fri] };
    var showroom = Object.assign({}, wk), online = Object.assign({}, wk);
    if (cfg.showroomSat > 0) showroom[6] = [cfg.open, cfg.showroomSat];
    if (cfg.onlineSat > 0) online[6] = [cfg.open, cfg.onlineSat];
    return { showroom: showroom, online: online };
  }

  function stateFor(sched, now, holidays) {
    var closedOn = function (offset) { return holidays.indexOf(isoPlus(now, offset)) !== -1; };
    var today = closedOn(0) ? null : sched[now.dow];
    if (today && today[1] > today[0] && now.hour >= today[0] && now.hour < today[1]) {
      var soon = today[1] - now.hour <= 1;
      return { key: soon ? 'soon' : 'open', state: soon ? 'Closing soon' : 'Open now', detail: '· until ' + fmt(today[1]) + ' AEST' };
    }
    var when = '';
    if (today && now.hour < today[0]) when = fmt(today[0]) + ' today';
    else {
      for (var i = 1; i <= 14; i++) {
        var dow = (now.dow + i) % 7;
        if (sched[dow] && !closedOn(i)) { when = fmt(sched[dow][0]) + ' ' + (i === 1 ? 'tomorrow' : (i < 7 ? DAYS[dow] : DAYS[dow] + ' ' + isoPlus(now, i).slice(8, 10) + '/' + isoPlus(now, i).slice(5, 7))); break; }
      }
    }
    return { key: 'closed', state: 'Closed', detail: when ? '· opens ' + when : '' };
  }

  function initHours(root) {
    var cfg, holidays;
    try { cfg = JSON.parse(root.getAttribute('data-hours')); } catch (e) { return; }
    try { holidays = JSON.parse(root.getAttribute('data-holidays') || '[]').map(function (s) { return String(s).trim(); }).filter(Boolean); } catch (e) { holidays = []; }
    var sch = schedules(cfg);
    function render() {
      var now = nowInBrisbane();
      root.querySelectorAll('[data-channel]').forEach(function (row) {
        var st = stateFor(sch[row.getAttribute('data-channel')], now, holidays);
        row.setAttribute('data-state', st.key);
        row.querySelector('[data-label]').textContent = st.state;
        row.querySelector('[data-detail]').textContent = st.detail;
      });
    }
    render();
    setInterval(render, 60000);
  }

  function initAccordions(root) {
    var mq = window.matchMedia('(min-width: 769px)');
    var items = root.querySelectorAll('[data-ampd-acc]');
    function sync() {
      items.forEach(function (d) {
        var summary = d.querySelector('summary');
        if (mq.matches) { d.open = true; summary.setAttribute('tabindex', '-1'); summary.setAttribute('role', 'heading'); summary.setAttribute('aria-level', '2'); }
        else { d.open = false; summary.removeAttribute('tabindex'); summary.removeAttribute('role'); summary.removeAttribute('aria-level'); }
      });
    }
    items.forEach(function (d) {
      d.querySelector('summary').addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); });
    });
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
  }

  function initLocale(root) {
    var sel = root.querySelector('[data-ampd-locale]');
    if (sel) sel.addEventListener('change', function () { sel.form.submit(); });
  }

  function init() {
    document.querySelectorAll('[data-ampd-footer]').forEach(function (root) {
      if (root.hasAttribute('data-ampd-footer-init')) return;
      root.setAttribute('data-ampd-footer-init', '');
      initHours(root);
      initAccordions(root);
      initLocale(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Re-run when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
